jQuery(document).ready(function($) {
    $('.quote__slider').slick({
        arrows: true,
        fade: true,
        autoplaySpeed: 5000,
        speed: 1500,
        autoplay: true,

        appendArrows: $('.quote__slider__arrows'),
        prevArrow: '<a href="#" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
        nextArrow: '<a href="#" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',

    });
});

jQuery(document).ready(function($) {
//  $('.quote__quote').textFit({multiLine:true});
});
